import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./error.css";

const E404 = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-code">404</div>
        <div className="error-message">Page Not Found</div>
        <Link to={isAuthenticated  ? "/home" :"/"}>BACK TO HOME</Link> 
      </div>
  
    </div>
  );
};

export default E404;
